var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDrawtoolRetracement = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.08594 3.33301H17.9193V4.58301H2.08594V3.33301ZM2.08594 6.24967H17.9193V7.49967H2.08594V6.24967ZM17.9193 9.16634H2.08594V10.4163H17.9193V9.16634Z",
  fill: "#7F7F7F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8307 12.5H15.4141V17.5H16.2474V15H18.3307V14.1667H16.2474V13.3333H18.3307V12.5H16.2474H15.8307Z",
  fill: "#7F7F7F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDrawtoolRetracement);
export { ForwardRef as ReactComponent };